/**
 * @author shaojingchao
 * @date 2019/06/13
 * @project kaoshizhongxin-pc
 * @description 首页
 */

import { API_URL } from '../config'
import request from '../utils/request'

const homeUrl = {
  index: API_URL + 'v1/home/data',
  paper: API_URL + 'v1/home/paper',
  finePaper: API_URL + 'v1/home/fine-paper',
  subject: API_URL + 'v1/home/subject',
  links: API_URL + 'v1/home/friend-links'
}

// 基础数据
export const homeDataApi = (config) => request.get(homeUrl.index, config)

// 最新试卷
export const homePaperApi = (params, config) => request.get(homeUrl.paper, {params, ...config})

// 精品试卷
export const homeFinePaperApi = (params, config) => request.get(homeUrl.finePaper, {params, ...config})

// 学科列表
export const homeSubjectApi = (config) => request.get(homeUrl.subject, config)

// 友情链接
export const homeLinksApi = (config) => request.get(homeUrl.links, config)
